import React from 'react';
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
export const TagManagementIcon = (props) => (<BallotOutlinedIcon {...props}/>);
export default TagManagementIcon;
